 <div class="recommendation-widget">
  <app-panel
    [title]="'DASHBOARD.LEARNING-IDEAS' | translate"
    *ngIf="(recommendations && recommendations.length) || !isLoaded"
  >
    <dx-button
      class="reload-btn"
      [class.spinning]="!isLoaded" 
      icon="refresh"
      type="normal"
      [disabled]="!isLoaded"
      (onClick)="handleReload()"
    ></dx-button>
    <ng-container *ngIf="!isLoaded; else learningRecommendationsTemplate">
      <app-component-loader [minHeight]="120" [diameter]="100"/>
    </ng-container>
    <ng-template #learningRecommendationsTemplate>
      <div class="carousel-wrapper">
        <button class="scroll-btn left-btn" (click)="scroll('left')" *ngIf="canScrollLeft">
          <i class="dx-icon dx-icon-chevronleft"></i>
        </button>
        <button class="scroll-btn right-btn" (click)="scroll('right')" *ngIf="canScrollRight">
          <i class="dx-icon dx-icon-chevronright"></i>
        </button>

        <div 
          #scrollContainer 
          class="learning-recommendations" 
          (scroll)="checkScrollLimits()"
        >
          <a 
            class="recommendation-card" 
            *ngFor="let recommendation of recommendations"
            [routerLink]="getRecommendationLink(recommendation)"
          >
            <div class="card-main-content">
              <div class="item-image">
                <img 
                  [src]="recommendation.imageUrl | safe:'url'" 
                  appTrainingImageFallback 
                />
              </div>
              <div class="item-text">
                <div class="item-title">{{ recommendation.name }}</div>
                <div class="item-description">{{ recommendation.description }}</div>
              </div>
            </div>

            <div class="card-footer">
              <div class="status">
                @if(isTraining(recommendation)) {
                  <span *ngIf="recommendation.date"> 
                    {{ 'COMMON.DATE' | translate }}: {{ recommendation.date.start | date:'dd.MM.yyyy' }} - {{ recommendation.date.start | date:'HH:mm' }}
                  </span>
                } @else {
                  @if(recommendation.lastVisited) {
                    <span>{{ 'COMMON.LAST-VISITED' | translate }}: {{ recommendation.lastVisited | date:'dd.MM.yyyy' }}</span>
                  } @else if(isComplianceTrainingType(recommendation)) {
                    <span>{{ 'COMMON.REQUIRED' | translate }}</span>
                  } @else {
                    <span>{{ 'COMMON.NOT-STARTED' | translate }}</span>
                  }
                }
              </div>

              <div 
                class="training-badge-container"  
                *ngIf="recommendation.categories?.length"
              >
                <div class="training-badge-content">
                  <span class="category">
                    {{ getTrainingCategoriesLabel(recommendation) }}
                  </span>
                </div>
              </div>

              <div class="training-badge-container">
                <div class="training-badge-content">
                  <i
                    class="dx-icon dx-svg-icon"
                    [innerHTML]="getCategoryIcon()"
                  ></i>
                  {{ getTrainingTypeLabel(recommendation.trainingType) }}
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </ng-template>
  </app-panel>
</div>